import React from 'react';
import Body from './Body';
import Header from './Header';

const Table = ({
  title,
  ariaLabel,
  ariaDescription,
}: {
  title: string;
  ariaLabel?: string;
  ariaDescription?: string;
}) => {
  return (
    <table
      className="grid__table"
      role="grid"
      aria-label={ariaLabel || title}
      aria-description={ariaDescription}
      title={title}
    >
      <caption style={{ display: 'none' }}>_{title}</caption>
      <Header />
      <Body />
    </table>
  );
};

export default React.memo(Table);
